
import { Component, OnInit, OnDestroy, Input, AfterViewInit, ViewChild, ElementRef, EventEmitter, Output, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { UserLogin } from '../../models/user-login.model';
import { ICD, MasterConfig, ResponseAPI, ErrorList, ICDStep3 } from '../../models/IDPReport.model';
import { SfDataService } from '../../services/sf-data.service';
import { AgentService, PreSubmitIssue } from '../../services/agent.service';
import { AiHintStateService } from '../../services/ai-hint-state.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../services/utilities';
import Swal from 'sweetalert2';

 


declare global {
  interface JQuery {
    datepicker(options?: any): any;
  }
}

interface JQuery<TElement = HTMLElement> {
  select2(options?: any): any;
}

interface JQuery {
  select2(options?: any): any;
}


// import custom validator to validate 
import { MustMatch } from '../../models/MustMatch';
import { dateNotLessThanTodayValidator } from '../../models/dateNotLessThanTodayValidator';

@Component({
    selector: 'app-sf-icd-terminate-contract',
    templateUrl: './sf-icd-terminate-contract.component.html',
    styleUrls: ['./sf-icd-terminate-contract.component.scss'],
    standalone: false
})
export class SfIcdTerminateContractComponent implements OnInit, AfterViewInit {
  icd = new ICDStep3();
  data = {
    name: 'John',
    age: 30
  };

  userLogin = new UserLogin(); id: string; q: string; fm: string; d: string;
  isLoading = false;
  isTestCampaign = false;
  formResetToggle = true;
  modalClosedCallback: () => void;
  loginStatusSubscription: any;
  selectedCountry: string;
  selected_WC_details: string
  icdForm: FormGroup;
  section1Form: FormGroup;
  section2Form: FormGroup;
  section3Form: FormGroup;
  section4Form: FormGroup;
  section5Form: FormGroup;
  section6Form: FormGroup;

  @Input()
  isModal = false;
  submitted = false;
  ddlUSStates = [];
  ddlBest_Delivery_Time = [];
  ddlCAProvinence = [];

  Canada_campaignData = [];
  Canada_retailsData = [];

  PO_namesData = [];
  NC_namesData = [];
  RC_namesData = [];


  US_campaignData = [];
  US_retailsData = [];
  icd_o = new ICD();
  @Output() dataEmitter = new EventEmitter<any>();
  @Input() inputData: any;
  selectedFiles: FileList;
  validFiles: File[] = [];
  fileData: { attachment_FileName: string, attachment_Base64: string, attachment_Type: string, FileId?: string, Url?: string, status?: 'uploading' | 'uploaded' | 'error' }[] = [];
  maxFilesAllowed: number = 15; // Maximum number of files allowed
  maxFileSize: number = 10 * 1024 * 1024; // 10 MB max file size (FR3)
  // Staged upload-on-select state, keyed by form control name.
  uploadState: { [controlName: string]: 'uploading' | 'uploaded' | 'error' } = {};
  uploadError: { [controlName: string]: string } = {};
  // Per-control selection counter so a slow FileReader from a superseded selection is ignored (FR2).
  private uploadSeq: { [controlName: string]: number } = {};

  US_Retails_selectedItems: any[] = [];
  US_Retails_isSelectedItemsinvalid = false;
  Canada_Retails_selectedItems: any[] = [];
  Canada_Retails_isSelectedItemsinvalid = false;
  US_Campaigns_selectedItems: any[] = [];
  US_Campaigns_isSelectedItemsinvalid = false;
  Canada_Campaigns_selectedItems: any[] = [];
  Canada_Campaigns_isSelectedItemsinvalid = false;
  Keep_Insurance_Active = '';
  Keep_Payroll_Active = '';
  Keep_Workers_Active = '';
  isOTPValid = false;
  btnDisplay = true;
  // Pre-submit review
  showPreSubmitReview = false;
  preSubmitIssues: PreSubmitIssue[] = [];
  preSubmitLoading = false;
  verificationState: { [controlName: string]: 'pending' | 'verifying' | 'pass' | 'fail' | 'warn' } = {};
  verificationIssues: { [controlName: string]: string[] } = {};
  private readonly VERIFIED_DOC_TYPES: { [controlName: string]: string } = {
    Attach_Termination_Agreement: 'TerminationAgreement',
  };

  public masterConfig: MasterConfig[] = [];

  datad = {
    name: '',
    age: 0
  };

  @Output() idEmitter = new EventEmitter<string>();
  //@ViewChild('dobInput') dobInput: ElementRef;
  @ViewChild('datepicker') datepicker: ElementRef;
  @ViewChild('selectEl') selectEl: ElementRef;

  select2Options = {
    placeholder: 'Select an option...',
    width: '100%'
  };

  selectedOption: string;

  controlDisplayNames: { [key: string]: string } = {

    Reason_for_Closure: 'Reason For Closure',

    Last_Date_Insurance: 'Last Date Insurance',

    Last_Date_WC_Coverage: 'Last Date WC Coverage',

    Last_Date_payroll: 'Last Date Payroll',

    Last_Date_Service: 'Last Date Service',

    Keep_Payroll_Active: 'Keep Payroll Active',

    Keep_Workers_Active: 'Keep Workers Active',

    Keep_Insurance_Active: 'Keep Insurance Active',

    Attach_NC_Recommendation: 'NC Recommendation',

    Attach_Termination_Agreement: 'Termination Agreement',

    TBD_Comments: 'TBD Comments'

  };

    fieldMaxLengths: any = {

      Reason_for_Closure: 255,

      TBD_Comments: 4000

    };

  constructor(private route: ActivatedRoute, private elRef: ElementRef, private fb: FormBuilder, private router: Router, private alertService: AlertService, private authService: AuthService, private configurations: ConfigurationService, private sfDataService: SfDataService, private agentService: AgentService, private hintStateService: AiHintStateService) { }

  @Output() activateTab = new EventEmitter<number>();

  ngOnInit(): void {


    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Attempting login...');
    //this.emitActivateTab(3);
    $('.detailchild').removeClass('active');
    $('.detailmain').removeClass('active');
    $('#custom-tabs-four-more-tab').addClass('active');

    $('.detailchild').removeClass('tabhighlight');
    $('#custom-tabs-close-icd').addClass('tabhighlight');
    $('#custom-tabs-four-more-tab').parent().addClass('active');

    this.id = this.route.snapshot.paramMap.get('id');

    this.fm = this.route.snapshot.paramMap.get('f');

    this.d = this.route.snapshot.paramMap.get('dcode');


    this.datad = this.inputData;
    this.CreateForm();

    this.BindDropdowns();
     
        this.idEmitter.emit(this.id);
        this.BindData(this.id);
       

  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: Event): void {
    event.preventDefault();
  }
  ShowOTPpopup(str: string) {
    Swal.fire({
      title: 'OTP!',
      text: str,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,
      input: 'text',
      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (!val) {
          Swal.showValidationMessage("OTP is required");
        } else {
          try {

            // Create a new instance of the ICD class
            let responseAPI = new ResponseAPI();
            this.sfDataService.getOTP(this.id, val, this.q)
              .subscribe(
                data => {

                  //responseAPI = data;
                  // Assign the received data to the responseAPI object
                  responseAPI = data;
                  if (responseAPI.isSuccess) {
                    this.isOTPValid = responseAPI.isSuccess;
                    this.idEmitter.emit(this.id);
                    this.BindData(this.id);
                  }
                  else {
                    // API call failed, reject the Promise to prevent closing the popup
                    this.ShowOTPpopup("Wrong Access Code, Enter Access Code to continue");
                  }

                },
                error => {

                  this.alertService.stopLoadingMessage();

                  if (Utilities.checkNoNetwork(error)) {
                    this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
                    this.offerAlternateHost();
                  } else {
                    const errorMessage = Utilities.getHttpResponseMessage(error);

                    if (errorMessage) {
                      this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
                    } else {
                      this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
                    }
                  }

                  setTimeout(() => {
                    this.isLoading = false;
                  }, 500);
                });

            // await this.apiService.postData(val);
            // API call succeeded, resolve the Promise
          } catch (error) {
            // API call failed, reject the Promise to prevent closing the popup
            return Promise.reject(error);
          }
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle success case when the API call is successful
      } else if (result.isDenied) {
        // Handle the case when the user cancels the dialog
      } else if (result.isDismissed) {
        // Handle the case when the dialog is closed without confirmation
      }
    });
  }

  CreateForm() {
    this.icdForm = this.fb.group({
      US_or_CA : [''],
      Full_Legal_Company_Name: [{ value: '', disabled: true }],
      
      Tax_ID: [{ value: '', disabled: true }],

      ICD_Owner_Name: [{ value: '', disabled: true }],

      HUB_Manager_Contact_Name: [{ value: '', disabled: true }],
      Reason_for_Closure: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Reason_for_Closure),this.noHtmlTagsValidator.bind(this)]],
      Last_Date_Insurance: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\-\d{4}$/)]],
      Last_Date_WC_Coverage: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\-\d{4}$/)]],
      Last_Date_payroll: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\-\d{4}$/)]],
      Last_Date_Service: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\-\d{4}$/)]],
      Keep_Payroll_Active: ['', Validators.required],
      Keep_Workers_Active: ['', Validators.required],
      Keep_Insurance_Active: ['', Validators.required],

      Attach_NC_Recommendation: [''],
      Attach_Termination_Agreement: [''],
      TBD_Comments:['', [Validators.maxLength(this.fieldMaxLengths.TBD_Comments), this.noHtmlTagsValidator.bind(this)]],
      Promoting_Owner_Company: [{ value: '', disabled: true }],
      Regional_Consultant_Company: [{ value: '', disabled: true }],

      National_Consultant_Company: [{ value: '', disabled: true }],

      Promoting_Owner: [{ value: '', disabled: true }],
      Regional_Consultant: [{ value: '', disabled: true }],

      National_Consultant: [{ value: '', disabled: true }]


    });


  }

  sendDataToParent() {
    this.dataEmitter.emit(this.datad);
  }
  // convenience getter for easy access to form fields
  get f() { return this.icdForm.controls; }

  get s1() { return this.section1Form.controls; }

  get items(): FormArray {
    return this.icdForm.get('items') as FormArray;
  }



  onCountryChange() {
    const US_or_CA = this.icdForm.get('US_or_CA').value;
    if (US_or_CA === 'US') {
      this.selectedCountry = "US";


      //this.icdForm.get('Attach_NC_Recommendation').setValidators([Validators.required]);      
      this.icdForm.get('Attach_Termination_Agreement').clearValidators();


    } else {
      this.selectedCountry = "Canada";



      //this.icdForm.get('Attach_NC_Recommendation').clearValidators();
      // Only required when Canada AND Keep Insurance Active = No — must match the *ngIf
      // in the template, or the upload can be hidden while still marked required.
      if (this.icdForm.get('Keep_Insurance_Active').value === 'No') {
        this.icdForm.get('Attach_Termination_Agreement').setValidators([Validators.required]);
      } else {
        this.icdForm.get('Attach_Termination_Agreement').clearValidators();
      }




    }

    //this.icdForm.get('Attach_NC_Recommendation').updateValueAndValidity();
    this.icdForm.get('Attach_Termination_Agreement').updateValueAndValidity();
    

  }

  onCheckboxChange_US_Retails(event: any, value: any) {
    if (event.target.checked) {
      this.US_Retails_selectedItems.push(value);
    } else {
      const index = this.US_Retails_selectedItems.indexOf(value);
      if (index > -1) {
        this.US_Retails_selectedItems.splice(index, 1);
      }
    }


    if (this.US_Retails_selectedItems.length <= 0) {
      this.US_Retails_isSelectedItemsinvalid = true;
    }
    else {
      this.US_Retails_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_Canada_Retails(event: any, value: any) {
    if (event.target.checked) {
      this.Canada_Retails_selectedItems.push(value);
    } else {
      const index = this.Canada_Retails_selectedItems.indexOf(value);
      if (index > -1) {
        this.Canada_Retails_selectedItems.splice(index, 1);
      }
    }


    if (this.Canada_Retails_selectedItems.length <= 0) {
      this.Canada_Retails_isSelectedItemsinvalid = true;
    }
    else {
      this.Canada_Retails_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_US_Campaigns(event: any, value: any) {

    if (event.target.checked) {
      if (value == "TestCampaign(NotListed)") {
        this.isTestCampaign = true;
        this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required]);
        this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

      }
      this.US_Campaigns_selectedItems.push(value);
    } else {
      this.isTestCampaign = false;
      this.icdForm.get('Company_Country').clearValidators();
      this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();
      const index = this.US_Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.US_Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.US_Campaigns_selectedItems.length <= 0) {
      this.US_Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.US_Campaigns_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_Canada_Campaigns(event: any, value: any) {
    if (event.target.checked) {
      this.Canada_Campaigns_selectedItems.push(value);
    } else {
      const index = this.Canada_Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.Canada_Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.Canada_Campaigns_selectedItems.length <= 0) {
      this.Canada_Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.Canada_Campaigns_isSelectedItemsinvalid = false;
    }


  }

  showErrorAlert(caption: string, message: string) {
    this.alertService.showMessage(caption, message, MessageSeverity.error);
  }

  // Front-end displays dates as MM-DD-YYYY; Salesforce stores them as YYYY-MM-DD.
  // Convert a UI MM-DD-YYYY value to YYYY-MM-DD before saving. Idempotent/safe for
  // empty or already-normalized values.
  private toSfDate(v: string): string {
    if (!v) { return v; }
    const m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(v.trim());
    return m ? `${m[3]}-${m[1]}-${m[2]}` : v;
  }

  // Convert a Salesforce YYYY-MM-DD (optionally with a time component) to the
  // MM-DD-YYYY the datepicker/UI expects. Safe for empty/invalid values.
  private toDisplayDate(v: string): string {
    if (!v) { return v; }
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v.trim());
    return m ? `${m[2]}-${m[3]}-${m[1]}` : v;
  }

  ngAfterViewInit() {

     $('#Last_Date_Insurance').datepicker({
      dateFormat: 'mm-dd-yy',
      changeMonth: true,
      changeYear: true,
       minDate: 0,
      onSelect: (dateText, inst) => {
        this.datepicker = dateText;
        this.icdForm.controls['Last_Date_Insurance'].patchValue(dateText);
        this.icdForm.controls['Last_Date_Insurance'].markAsTouched();
        this.icdForm.controls['Last_Date_Insurance'].updateValueAndValidity();
      }
    });


     $('#Last_Date_WC_Coverage').datepicker({
      dateFormat: 'mm-dd-yy',
      changeMonth: true,
      changeYear: true,
       minDate: 0,
      onSelect: (dateText, inst) => {
        this.datepicker = dateText;
        this.icdForm.controls['Last_Date_WC_Coverage'].patchValue(dateText);
        this.icdForm.controls['Last_Date_WC_Coverage'].markAsTouched();
        this.icdForm.controls['Last_Date_WC_Coverage'].updateValueAndValidity();
      }
    });



    $('#Last_Date_payroll').datepicker({
      dateFormat: 'mm-dd-yy',
      changeMonth: true,
      changeYear: true,
      // minDate: 0,
      onSelect: (dateText, inst) => {
        this.datepicker = dateText;
        this.icdForm.controls['Last_Date_payroll'].patchValue(dateText);
        this.icdForm.controls['Last_Date_payroll'].markAsTouched();
        this.icdForm.controls['Last_Date_payroll'].updateValueAndValidity();
      }
    });



     $('#Last_Date_Service').datepicker({
      dateFormat: 'mm-dd-yy',
      changeMonth: true,
      changeYear: true,
      // minDate: 0,
      onSelect: (dateText, inst) => {
        this.datepicker = dateText;
        this.icdForm.controls['Last_Date_Service'].patchValue(dateText);
        this.icdForm.controls['Last_Date_Service'].markAsTouched();
        this.icdForm.controls['Last_Date_Service'].updateValueAndValidity();
      }
    });

  }

  closeModal() {
    if (this.modalClosedCallback) {
      this.modalClosedCallback();
    }
  }

  onSubmit() {
    this.hintStateService.collapse();

    this.submitted = true;

    // FR1: do not submit while a file is still uploading to staging.
    if (this.hasUploadsInFlight()) {
      this.alertService.showMessage('Please wait', 'A file is still uploading. Please wait until it finishes before submitting.', MessageSeverity.error);
      this.Showsuccesspopup1('A file is still uploading. Please wait until it finishes before submitting.');
      return;
    }

    this.trimFormValues();


    // stop here if form is invalid
    if (this.icdForm.invalid) {


      const formControls = this.icdForm.controls;

      // Initialize an array to store invalid controls
      const invalidControls: string[] = [];

      // Iterate through the form controls and check if they are invalid
      Object.keys(formControls).forEach(controlName => {
        const control = this.icdForm.get(controlName);

        if (control?.invalid) {
          let displayName =
            this.controlDisplayNames[controlName] || controlName;

          if (control.errors?.invalidHtml) {
            displayName += ' (HTML/script not allowed)';
          }
          invalidControls.push(displayName);
        }
      });

      // Now, the 'invalidControls' array contains the names of all invalid form controls
      ////console.log('Invalid controls:', invalidControls);
      const commaSeparated = invalidControls.join(', ');

      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();
      this.alertService.showMessage('Enter required fields', commaSeparated, MessageSeverity.error);
      this.Showsuccesspopup1('Enter required fields :' + commaSeparated);

      return;
    }

    this.showPreSubmitReview = true;
    this.runPreSubmitReview();

  }


  Showsuccesspopup1(str: string) {
    Swal.fire({
      title: str,
      icon: 'error',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

          //location.reload();
        }
      },
    }).then((result) => {

    });
  }


  fileValidator(control: any) {
    const files = control.value;
    
    if (!files || files.length === 0) {
      return null;
    }
    if (files.length + this.fileData.length > this.maxFilesAllowed) {
      return { maxFilesExceeded: true };
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!this.isValidFileFormat(file)) {
        return { invalidFormat: true };
      }

      if (file.size > this.maxFileSize) {
        return { fileSizeExceeded: true };
      }
    }

    return null;
  }

  //onFileSelected(event: any, inputId: string) {

  //  const files = event.target.files;


  //  for (let i = 0; i < files.length; i++) {
  //    const file = files[i];

  //    if (!this.isValidFileFormat(file)) {
  //      //console.log('Invalid file format:', file.name);
  //      this.icdForm.get('Attach_US_Articles_of_Incorporation').setErrors({ invalidFormat: true });

  //      continue;
  //    }

  //    const reader = new FileReader();
  //    reader.readAsDataURL(file);

  //    reader.onload = () => {
  //      const base64 = reader.result.toString().split(',')[1];
  //      this.fileData.push({ name: file.name, base64 });

  //      // Update the 'Attach_1' form control with the selected file name
  //      this.icdForm.patchValue({ Attach_US_Articles_of_Incorporation: file.name });

  //    };
  //  }

  //  this.uploadFiles();
  //}
  onFileSelected(event: any, controlName: string) {
    const files = event.target.files;
    const errors = [];
    const errorMessages: string[] = [];
    // Remove previously selected files for this control
    this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);

    if (!files || files.length === 0) {
      this.icdForm.get(controlName).setErrors({ noFileSelected: true });
      this.icdForm.get(controlName).updateValueAndValidity();
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // Check for valid file format
      if (!this.isValidFileFormat(file)) {
        errorMessages.push(
          `Invalid file format for "${file.name}". 
     Allowed formats: all image files (JPG, PNG, HEIC, etc.), PDF, Word (DOC, DOCX), Excel (XLS, XLSX), and CSV.`
        );

        //console.log('Invalid file format:', file.name);
        errors.push({ invalidFormat: true });
      }

      // Check for file size limit
      if (file.size > this.maxFileSize) {
        errorMessages.push(`File size exceeds 25 MB limit for file "${file.name}".`);
        //console.log('File size exceeds the limit:', file.name);
        errors.push({ fileSizeExceeded: true });
      }
    }

    // Set errors if any exist
    if (errors.length > 0) {
      const combinedMessage = errorMessages.join('\n');

      this.alertService.showMessage(combinedMessage, '.', MessageSeverity.error);
      this.Showsuccesspopup1(combinedMessage);
      this.icdForm.get(controlName).setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      const control = this.icdForm.get(controlName);

      // 🔥 CRITICAL FIX
      control?.setValue(null);
      control?.setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      control?.markAsTouched();
      control?.updateValueAndValidity({ emitEvent: false });

      // optional: clear DOM input too
      event.target.value = '';
      return; // 👈 stop here

    } else {
      // ---------- SUCCESS: upload each file to staging on select (FR1) ----------
      this.uploadState[controlName] = 'uploading';
      this.uploadError[controlName] = '';
      const inputEl = event.target as HTMLInputElement;
      // Bump the selection counter; a superseded selection's FileReader result is discarded (FR2).
      const seq = this.uploadSeq[controlName] = (this.uploadSeq[controlName] || 0) + 1;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => {
          if (this.uploadSeq[controlName] !== seq) { return; } // a newer selection superseded this one
          const b64 = reader.result!.toString().split(',')[1];
          const entry: { attachment_FileName: string, attachment_Base64: string, attachment_Type: string, FileId?: string, Url?: string, status?: 'uploading' | 'uploaded' | 'error' } = {
            attachment_FileName: file.name,
            attachment_Base64: b64,
            attachment_Type: controlName,
            status: 'uploading'
          };
          this.fileData.push(entry);
          this.triggerDocumentVerification(controlName);
          this.stageFile(entry, controlName, inputEl);
        };
      }

      const control = this.icdForm.get(controlName);
      control?.setErrors(null);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    }
  }

  // Uploads a single file to the staging area. A response from a previously replaced/cancelled
  // upload is ignored via object identity: if the entry is no longer in fileData, discard it (FR2).
  private stageFile(entry: any, controlName: string, inputEl: HTMLInputElement): void {
    const body = {
      CaseID: this.icd?.CaseID || this.icd?.AccountID || '',
      Attachment_FileName: entry.attachment_FileName,
      Attachment_Base64: entry.attachment_Base64,
      Owner_Email: this.icdForm?.get('Owner_Email')?.value || this.icd?.Owner_Email || this.icdForm?.get('Company_Business_Email')?.value || this.icd?.Company_Business_Email || this.icdForm?.get('HUB_Manager_Contact_Email')?.value || this.icd?.HUB_Manager_Contact_Email || this.icd?.HUB_Assistance_Email || '',
      Owner_Name: ((this.icd?.Owner_First_Name || '') + ' ' + (this.icd?.Owner_Last_Name || '')).trim(),
      Tax_ID: this.icd?.Tax_ID || ''
    };

    entry.StagingUniqueId = body.CaseID;

    this.sfDataService.stageAttachment(body).subscribe({
      next: (res: any) => {
        if (!this.fileData.includes(entry)) { return; } // superseded by a newer selection (FR2)
        if (res && res.isSuccess) {
          entry.FileId = res.fileId;
          entry.Url = res.url;
          entry.status = 'uploaded';
        } else {
          entry.status = 'error';
          this.removeStagedEntry(entry, inputEl);
          this.uploadError[controlName] = (res && res.errorMessage) ? res.errorMessage : 'Upload failed — please re-select the file.';
        }
        this.recomputeUploadState(controlName);
      },
      error: (err: any) => {
        if (!this.fileData.includes(entry)) { return; }
        entry.status = 'error';
        this.removeStagedEntry(entry, inputEl);
        this.uploadError[controlName] = this.extractServerError(err);
        this.recomputeUploadState(controlName);
      }
    });
  }

  // FR5: a failed file must not be silently submitted — drop it and force a re-select.
  private removeStagedEntry(entry: any, inputEl: HTMLInputElement): void {
    this.fileData = this.fileData.filter(f => f !== entry);
    const control = this.icdForm.get(entry.attachment_Type);
    if (inputEl) { inputEl.value = ''; }
    if (control?.hasValidator?.(Validators.required)) {
      control.setErrors({ required: true });
    }
    control?.markAsTouched();
  }

  private recomputeUploadState(controlName: string): void {
    const entries = this.fileData.filter(f => f.attachment_Type === controlName);
    if (entries.some(e => e.status === 'uploading')) {
      this.uploadState[controlName] = 'uploading';
    } else if (entries.length > 0 && entries.every(e => e.status === 'uploaded')) {
      this.uploadState[controlName] = 'uploaded';
      this.uploadError[controlName] = '';
    } else if (entries.length === 0 && this.uploadError[controlName]) {
      this.uploadState[controlName] = 'error';
    } else if (entries.length === 0) {
      delete this.uploadState[controlName];
    }
  }

  private extractServerError(err: any): string {
    try {
      if (err?.error?.errorMessage) { return err.error.errorMessage; }
      if (typeof err?.error === 'string' && err.error) { return err.error; }
      if (err?.message) { return err.message; }
    } catch { /* ignore */ }
    return 'Upload failed — please re-select the file.';
  }

  // FR1: block submission while any staged upload is still resolving.
  hasUploadsInFlight(): boolean {
    return this.fileData.some(f => f.status === 'uploading');
  }


  isInvalid(controlName: string): boolean {
    const control = this.icdForm.get(controlName);
    return control.touched && control.invalid;
  }


  public openFile(name: string, type: string): void {
    this.getBase64DownloadUrl(name, type).then((url: string) => {
      window.open(url, '_blank');
    });
  }

  public getBase64DownloadUrl(name: string, type: string): Promise<string> {
    const file = this.fileData.find(f => f.attachment_FileName === name && f.attachment_Type === type);

    if (file) {
      const fileExtension = this.getFileExtension(name);
      const mimeType = this.getMimeType(fileExtension);
      const base64Data = file.attachment_Base64;

      return Promise.resolve(`data:${mimeType};base64,${base64Data}`);
    } else {
      return Promise.reject(new Error('File not found.'));
    }
  }


  private getFileExtension(fileName: string): string {
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return fileExtension;
  }


  private getMimeType(fileExtension: string): string {
    // Map the file extension to the corresponding MIME type
    const mimeTypeMap = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png'
    };

    return mimeTypeMap[fileExtension];
  }


  isValidFileFormat(file: File): boolean {
    const allowedMimePrefixes = [
      'image/' // all image types (jpg, png, heic, webp, etc.)
    ];

    const allowedExactMimeTypes = [
      // PDF
      'application/pdf',

      // Word
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

      // Excel
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

      // CSV (different browsers report it differently)
      'text/csv',
      'application/csv',
      'text/plain'
    ];

    // 1️⃣ Primary check (modern browsers)
    if (file.type) {
      if (allowedMimePrefixes.some(prefix => file.type.startsWith(prefix))) {
        return true;
      }

      if (allowedExactMimeTypes.includes(file.type)) {
        return true;
      }
    }

    // 2️⃣ Fallback (Safari / iOS / older browsers)
    const allowedExtensions = [
      // images
      'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif',

      // documents
      'pdf', 'doc', 'docx',

      // excel
      'xls', 'xlsx',

      // csv
      'csv'
    ];

    const extension = file.name.split('.').pop()?.toLowerCase();
    return !!extension && allowedExtensions.includes(extension);
  }


  uploadFiles() {
    //const formData = new FormData();

    //for (let i = 0; i < this.validFiles.length; i++) {
    //  formData.append('files[]', this.validFiles[i]);
    //}

    //console.log(this.fileData)
    //this.http.post('https://example.com/upload', formData).subscribe(
    //  (response) => {
    //    //console.log('Upload successful', response);
    //  },
    //  (error) => {
    //    //console.log('Upload error', error);
    //  }
    //);
  }


  // Check if the first five fields are valid
  areFirstFiveFieldsValid(firstFiveFields: any): boolean {


    for (const fieldName of firstFiveFields) {
      const fieldControl = this.icdForm.get(fieldName);
      if (fieldControl && fieldControl.invalid) {
        return false;
      }
    }

    return true;
  }

  // Example implementation of getErrorMessage function
  getErrorMessage(fieldName: string): string {
    const control = this.icdForm.get(fieldName);

    if (control?.errors) {
      if (control.errors.required) {
        return 'This field is required.';
      }
      if (control.errors.invalidHtml) {
        return 'HTML or script content is not allowed.';
      }
      // Add additional error messages for specific validation rules as needed
    }

    return 'Invalid field.';
  }

  saveData(isSubmitted: boolean) {
    //debugger;
    this.isLoading = true;
    this.btnDisplay = false;
    this.alertService.startLoadingMessage('', 'Data Submitting...');

    // Get the form values as an object
    const formValues = this.icdForm.getRawValue();



    // Set the properties of the ICD instance with the form values
    this.icd.US_or_CA = formValues.US_or_CA;
    
    // this.icd.Years_in_Business = formValues.Years_in_Business;

    this.icd.Reason_for_Closure = formValues.Reason_for_Closure;
    this.icd.Last_Date_Insurance = this.toSfDate(formValues.Last_Date_Insurance);
    this.icd.Last_Date_WC_Coverage = this.toSfDate(formValues.Last_Date_WC_Coverage);
    this.icd.Last_Date_payroll = this.toSfDate(formValues.Last_Date_payroll);
    this.icd.Last_Date_Service = this.toSfDate(formValues.Last_Date_Service);
    this.icd.Keep_Payroll_Active = formValues.Keep_Payroll_Active;
    this.icd.Keep_Workers_Active = formValues.Keep_Workers_Active;
    this.icd.Keep_Insurance_Active = formValues.Keep_Insurance_Active;

    this.icd.TBD_Comments = formValues.TBD_Comments;

    //this.icd.Attach_NC_Recommendation = formValues.Attach_NC_Recommendation;
    //this.icd.Tax_ID = formValues.Tax_ID;

    const attachFields = [
      'Attach_NC_Recommendation',
      'Attach_Termination_Agreement'
    ];

    for (const field of attachFields) {
      const filteredBase64Array = this.fileData
        .filter(file => file.attachment_Type === field)
        .map(file => file.attachment_Base64);

      const commaSeparatedBase64 = filteredBase64Array.join('$$$');

      this.icd[field] = commaSeparatedBase64;
    }


    // FR4/FR7: send only successfully-staged files (carrying FileId for the confirm/move call)
    // plus their metadata/content for DB retention. Errored/in-flight files are excluded.
    this.icd.Attachments = this.fileData.filter(f => f.status === 'uploaded');
    this.icd.IsSubmitted = isSubmitted;
    //console.log(this.icd);
    this.SaveDatatoDB();

  }

  ShowSuccesspopup() {
    Swal.fire({
      title: 'Data Saved Successfully!',
      icon: 'success',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

        }
      },
    }).then((result) => {
      let url = '/icdreport/';
      this.router.navigate([url]);
    });
  }

  ChangeReason_for_Closure() {
    this.Keep_Insurance_Active = this.icdForm.get('Reason_for_Closure').value;
    const field = this.icdForm.get('TBD_Comments');

    if (this.Keep_Insurance_Active === 'TBD') {
      field.setValidators([Validators.required]);
      
    } else {
      field.clearValidators();
      
    }

    field.updateValueAndValidity();
  }

  ChangeInsuranceActive() {
    this.Keep_Insurance_Active = this.icdForm.get('Keep_Insurance_Active').value;
    const field = this.icdForm.get('Last_Date_Insurance');

    if (this.Keep_Insurance_Active === 'No') {
      field.setValidators([Validators.required, Validators.pattern(/^(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\-\d{4}$/)]);
      field.enable();
    } else {
      field.clearValidators();
      field.disable();
    }

    field.updateValueAndValidity();

    // Attach_Termination_Agreement's required state also depends on Keep_Insurance_Active,
    // not just country — re-run onCountryChange() so it re-evaluates against current values.
    this.onCountryChange();
  }

  ChangeKeep_Workers_Active() {
    this.Keep_Workers_Active = this.icdForm.get('Keep_Workers_Active').value;
    const field = this.icdForm.get('Last_Date_WC_Coverage');

    if (this.Keep_Workers_Active === 'No') {
      field.setValidators([Validators.required, Validators.pattern(/^(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\-\d{4}$/)]);
      field.enable();
    } else {
      field.clearValidators();
      field.disable();
    }

    field.updateValueAndValidity();
  }

  ChangeKeep_Payroll_Active() {
    this.Keep_Payroll_Active = this.icdForm.get('Keep_Payroll_Active').value;
    const field = this.icdForm.get('Last_Date_payroll');

    if (this.Keep_Payroll_Active === 'No') {
      field.setValidators([Validators.required, Validators.pattern(/^(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\-\d{4}$/)]);
      field.enable();
    } else {
      field.clearValidators();
      field.disable();
    }

    field.updateValueAndValidity();
  }


  SaveDatatoDB() {
    Swal.fire({
      title: 'Submitting data...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    // Create a new instance of the ICD class
    let responseAPI = new ResponseAPI();
    this.sfDataService.CreateOffBoard(this.icd)
      .subscribe(
        data => {
          Swal.close();
          //responseAPI = data;
          // Assign the received data to the responseAPI object
          responseAPI = data;
          if (responseAPI.isSuccess && !responseAPI.isValidationError) {
            //location.reload();

            //setTimeout(() => {
            this.alertService.showMessage('ICD', `Data Saved Successfully`, MessageSeverity.success);
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.ShowSuccesspopup();

            //}, 200);
          }
          else {
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.btnDisplay = true;

            // FR6: surface the real server message (e.g. document move/confirm failure) rather
            // than a generic error, and guard against a missing ErrorList payload.
            const serverMessage = responseAPI.description
              || (responseAPI.data && responseAPI.data.error && responseAPI.data.error.message)
              || 'An error occurred while saving data. Please try again.';
            const errorCode = (responseAPI.data && responseAPI.data.error && responseAPI.data.error.errorCode) || '';

            this.alertService.showMessage('ICD', 'Submission failed', MessageSeverity.error);
            this.alertService.showStickyMessage('Unable to store data', serverMessage, MessageSeverity.error, errorCode);
          }

        },
        error => {
          Swal.close();
          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
            this.btnDisplay = true;
          }, 500);
        });

  }

  numberValidator(control: FormControl) {
    const isValid = /^\d+$/.test(control.value);
    return isValid ? null : { 'invalidNumber': true };
  }

  BindDropdowns() {
    //debugger;
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');

    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    this.sfDataService.getMasterConfigs("US_State,Canada_Province,US_Retails,US_Campaigns,Canada_Retails,Canada_Campaigns,DeliveryTime")
      .subscribe(
        data => {
          ////console.log(data);
          //debugger;
          this.masterConfig = data;
          this.ddlUSStates = this.masterConfig.filter(a => a.type == "US_State");
          this.ddlCAProvinence = this.masterConfig.filter(a => a.type == "Canada_Province");
          //this.Canada_campaignData = this.masterConfig.filter(a => a.type == "Canada_Campaigns");
          //   this.Canada_retailsData = this.masterConfig.filter(a => a.type == "Canada_Retails");
          // this.US_campaignData = this.masterConfig.filter(a => a.type == "US_Campaigns");
          //  this.US_retailsData = this.masterConfig.filter(a => a.type == "US_Retails");
          this.ddlBest_Delivery_Time = this.masterConfig.filter(a => a.type == "DeliveryTime");
          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });

    this.sfDataService.getAddInfoDDs().subscribe(resp => {
      ////console.log(resp);

      let res: any;

      res = resp;

      this.NC_namesData = res.ncNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));
      ;
      this.RC_namesData = res.rcNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));;
      this.PO_namesData = res.poNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));;
      
      ////console.log(this.NC_namesData)

      ////console.log(this.Canada_campaignData)
    });

    

  }

  private mapDataToICD(data: any) {
    if (data == null) {

      this.icdForm.disable();
      this.alertService.showMessage('ICD', `This Case is not assigned to view`, MessageSeverity.error);
      this.alertService.startLoadingMessage('', 'This Case is not assigned to view');
      this.alertService.showStickyMessage('ICD', 'This Case is not assigned to view', MessageSeverity.error, "");
      this.btnDisplay = false;

      return;
    }

    this.icdForm.controls['US_or_CA'].setValue(data.uS_or_CA);
    this.onCountryChange();
    this.icdForm.controls['Full_Legal_Company_Name'].setValue(data.full_Legal_Company_Name);
    this.icdForm.controls['ICD_Owner_Name'].setValue(data.owner_Name);
    this.icdForm.controls['Tax_ID'].setValue(data.tax_ID);
    this.icdForm.controls['HUB_Manager_Contact_Name'].setValue(data.huB_Manager_Contact_Name);

    this.icdForm.controls['Reason_for_Closure'].setValue(data.reason_for_Closure);
    this.icdForm.controls['Last_Date_Insurance'].setValue(this.toDisplayDate(data.last_Date_Insurance));
    this.icdForm.controls['Last_Date_WC_Coverage'].setValue(this.toDisplayDate(data.last_Date_WC_Coverage));
    this.icdForm.controls['Last_Date_payroll'].setValue(this.toDisplayDate(data.last_Date_payroll));
    this.icdForm.controls['Last_Date_Service'].setValue(this.toDisplayDate(data.last_Date_Service));

    this.icdForm.controls['Promoting_Owner'].setValue(data.promotingOwner);
    this.icdForm.controls['Promoting_Owner_Company'].setValue(data.promotingOwnerCompany);
    this.icdForm.controls['Regional_Consultant'].setValue(data.regionalConsultant);
    this.icdForm.controls['Regional_Consultant_Company'].setValue(data.regionalConsultantCompany);
    this.icdForm.controls['National_Consultant'].setValue(data.nationalConsultant);
    this.icdForm.controls['National_Consultant_Company'].setValue(data.nationalConsultantCompany);


    this.icd.AccountID = data.accountID;

    this.icd.HUB_Manager_Contact = data.huB_Manager_Contact;
    this.icd.HUB_Manager_Contact_Name = data.huB_Manager_Contact_Name;
    this.icd.HUB_Manager_Contact_Number = data.huB_Manager_Contact_Number;
    this.icd.HUB_Manager_Contact_Email = data.huB_Manager_Contact_Email;
    this.icd.HUB_Assistance_Email = data.huB_Assistance_Email;
    this.icd.Tax_ID = data.tax_ID;
    this.icd.Company_Address1 = data.homeAddress;
    this.icd.Company_Address2 = data.homeAddress2;
    this.icd.Company_City = data.homeCity;
    this.icd.Company_Postal_Code = data.homeZipCode;
    this.icd.Company_Office_Phone = data.homePhone;
    this.icd.Company_State = data.homeState;
    this.icd.Company_Province = data.homeState;
    this.icd.Owner_Office_Phone = data.owner_Office_Phone;
    this.icd.Full_Legal_Company_Name = data.full_Legal_Company_Name;
    this.icd.Owner_First_Name = data.owner_First_Name;
    this.icd.Owner_Last_Name = data.owner_Last_Name;
    this.icd.Owner_Name = data.owner_Name;
    this.icd.Owner_Email = data.owner_Email;
    this.icd.PromotingOwner = data.promotingOwner;
    this.icd.PromotingOwnerCompany = data.promotingOwnerCompany;
    this.icd.RegionalConsultant = data.regionalConsultant;
    this.icd.RegionalConsultantCompany = data.regionalConsultantCompany;
    this.icd.NationalConsultant = data.nationalConsultant;
    this.icd.NationalConsultantCompany = data.nationalConsultantCompany;
    this.icd.CaseID = data.caseID;
    this.icd.Distributor_Code = this.d;
    this.icd.ContactID = data.contactID;
    if (data.attachments != null) {
      for (let i = 0; i < data.attachments.length; i++) {
        const file = data.attachments[i];

        this.fileData.push({ attachment_FileName: file.attachment_FileName, attachment_Base64: file.attachment_Base64, attachment_Type: file.attachment_Type });
      }

    }

    this.dataEmitter.emit(this.datad);


  }

  BindData(id: string) {
    //debugger;

    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');
    //this.icd.Owner_Email = this.icdForm.value["Owner_email
    if (this.f != null && this.d != null) {
      this.sfDataService.getICDStep3byAcc(id)
      .subscribe(
        data => {
          ////console.log(data);
          //debugger;

          this.mapDataToICD(data);
          ////console.log(data);


          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
}
    else {
      this.sfDataService.getICDStep3(id)
        .subscribe(
          data => {
            ////console.log(data);
            //debugger;

            this.mapDataToICD(data);
            ////console.log(data);


            this.alertService.stopLoadingMessage();
          },
          error => {

            this.alertService.stopLoadingMessage();

            if (Utilities.checkNoNetwork(error)) {
              this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
              this.offerAlternateHost();
            } else {
              const errorMessage = Utilities.getHttpResponseMessage(error);

              if (errorMessage) {
                this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
              } else {
                this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
              }
            }

            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
}
    
  }

  mapLoginErrorMessage(error: string) {

    if (error === 'invalid_username_or_password') {
      return 'Invalid username or password';
    }

    if (error === 'invalid_grant') {
      return 'This account has been disabled';
    }

    return error;
  }

  offerAlternateHost() {

    if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
      this.alertService.showDialog('Dear Developer!\nIt appears your backend Web API service is not running...\n' +
        'Would you want to temporarily switch to the online Demo API below?(Or specify another)',
        DialogType.prompt,
        (value: string) => {
          this.configurations.baseUrl = value;
          this.alertService.showStickyMessage('API Changed!', 'The target Web API has been changed to: ' + value, MessageSeverity.warn);
        },
        null,
        null,
        null,
        this.configurations.fallbackBaseUrl);
    }
  }

  trimFormValues() {

    // Avoid setting value on file inputs. Skip controls that look like file attachments
    // (names starting with "Attach_") or whose value is a File/FileList/object.
    Object.keys(this.icdForm.controls).forEach(key => {
      // Skip known file-type controls
      if (/^Attach_/i.test(key) || /Attach/i.test(key)) {
        return;
      }

      const control = this.icdForm.get(key);
      if (!control) {
        return;
      }

      const val = control.value;

      // Skip File / FileList / object values to avoid InvalidStateError
      if (val instanceof File || (typeof FileList !== 'undefined' && val instanceof FileList) || typeof val === 'object') {
        return;
      }

      if (typeof val === 'string') {
        try {
          control.setValue(val.trim());
        } catch (e) {
          // don't break form processing on single control error
          console.warn(`trimFormValues: skipped trimming control '${key}' due to error`, e);
        }
      }
    });
  }

  noHtmlTagsValidator(control: any) {

    if (!control.value) {
      return null;
    }

    const value = control.value.toString().trim();

    const htmlPattern =
      /(<[^>]+>|&lt;|&gt;|javascript:|onerror=|onload=|<script|<\/script>)/gi;

    if (htmlPattern.test(value)) {
      return { invalidHtml: true };
    }

    return null;
  }

  reset() {
    this.formResetToggle = false;

    setTimeout(() => {
      this.formResetToggle = true;
    });
  }
  buildFormSnapshot(): Record<string, string> {
    const raw = this.icdForm.getRawValue();
    const snap: Record<string, string> = {};
    Object.keys(raw).forEach(k => {
      const ctrl = this.icdForm.get(k);
      if (ctrl && ctrl.disabled) { return; } // skip disabled/read-only fields — user cannot act on the advisory
      const v = raw[k];
      if (v !== null && v !== undefined && v !== '' && typeof v !== 'object') {
        snap[k] = String(v);
      }
    });
    return snap;
  }

  runPreSubmitReview(): void {
    this.preSubmitLoading = true;
    this.preSubmitIssues = [];
    const snapshot = this.buildFormSnapshot();
    this.agentService.getPreSubmitReview(snapshot).pipe(
      catchError(() => of({ issues: [] }))
    ).subscribe(res => {
      this.preSubmitIssues = res?.issues ?? [];
      this.preSubmitLoading = false;
    });
  }

  onPreSubmitDismiss(): void { this.showPreSubmitReview = false; }

  onPreSubmitDoSubmit(): void {
    this.showPreSubmitReview = false;
    this.saveData(true);
  }

  onPreSubmitRecheck(): void { this.runPreSubmitReview(); }

  onPreSubmitAutoFix(fix: { fieldName: string; suggestedFix: string }): void {
    const ctrl = this.icdForm.get(fix.fieldName);
    if (ctrl) { ctrl.setValue(fix.suggestedFix); ctrl.markAsDirty(); }
  }

  onPreSubmitNavigate(fieldName: string): void {
    const el = document.getElementById(fieldName) || document.querySelector(`[formcontrolname="${fieldName}"]`);
    if (el) (el as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  private triggerDocumentVerification(controlName: string): void {
    const docType = this.VERIFIED_DOC_TYPES[controlName];
    if (!docType) return;

    const fileEntry = this.fileData.find(f => f.attachment_Type === controlName);
    if (!fileEntry) return;

    this.verificationState[controlName] = 'verifying';
    this.verificationIssues[controlName] = [];

    const ext = fileEntry.attachment_FileName.split('.').pop()?.toLowerCase() ?? '';
    const mimeMap: Record<string, string> = {
      pdf: 'application/pdf', jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', xls: 'application/vnd.ms-excel', csv: 'text/csv'
    };
    const mimeType = mimeMap[ext] ?? 'application/octet-stream';

    const formValues = this.icdForm.getRawValue();
    const body = {
      documentType: docType,
      base64Content: fileEntry.attachment_Base64,
      mimeType,
      companyName: formValues.Full_Legal_Company_Name || '',
      taxId: formValues.Tax_ID || '',
      stateOfIncorporation: formValues.State_of_Incorporation || '',
      provinceOfIncorporation: formValues.Provinence_of_Incorporation || '',
      dateOfIncorporation: '',
    };

    this.sfDataService.verifyDocument(body).subscribe({
      next: (result: any) => {
        if (result.overallPass) {
          this.verificationState[controlName] = result.issues && result.issues.length > 0 ? 'warn' : 'pass';
        } else {
          this.verificationState[controlName] = 'warn';
        }
        this.verificationIssues[controlName] = result.issues || [];
      },
      error: () => {
        this.verificationState[controlName] = 'warn';
        this.verificationIssues[controlName] = ['Document verification unavailable — please verify manually.'];
      }
    });
  }


}




